// extracted by mini-css-extract-plugin
export var link = "Link-module--link--a20bd";
export var linkExternal = "Link-module--link-external--e1dee";
export var linkUnderline = "Link-module--link-underline--2c184";
export var linkWrapper = "Link-module--link-wrapper--1a5ff";